<template>
  <nav>

    <!-- Navigation Top -->
    <v-app-bar flat style="z-index: 2;">

      <v-app-bar-nav-icon v-if="loggedIn" class="grey--text" app @click="drawer = !drawer" />

      <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" class="text-uppercase grey--text pl-4">
        <v-tooltip right color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              hover
              plain
              tile
              v-bind="attrs"
              elevation="0"
              text
              to="/"
              class="ml-0"
              v-on="on"
            >
              <span class="font-weight-regular">Katana</span>
              <span v-if="userData.company" class="ml-1 font-weight-light"> -
                {{ compData.name }}</span>
              <span v-else class="ml-1 font-weight-light"> - Invité</span>
            </v-btn>
          </template>

          <span>
            <v-icon left small color="white">mdi-view-dashboard</v-icon>Retour au Dashboard
          </span>
        </v-tooltip>

      </v-toolbar-title>

      <v-spacer />

      <div v-if="loggedIn && $route.name && !$route.name.toLowerCase().includes('task')">
        <v-btn outlined text small class="float-right text-truncate" @click="dialogs.todo = true">
          + Tâche
        </v-btn>
        <TaskAddDialog v-if="userData.company" v-model="dialogs.todo" :userInfo="userData" />
      </div>

      <DarkModeSwitch class="ml-4" />

      <v-btn
        v-if="loggedIn"
        icon
        class="ml-2"
        @click="drawerNotifications = !drawerNotifications"
      >
        <v-badge
          :content="notificationsStore.unreadCount"
          :value="notificationsStore.unreadCount > 0"
          color="info"
          overlap
        >
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>

      <v-list-item-avatar v-if="loggedIn" app @click="drawer2 = !drawer2">
        <v-img
          v-if="loggedIn && userData.avatar"
          :alt="`${userData.firstName}'s avatar`"
          :src="$functions.getImgLink(userData.avatar, 200)"
        />
        <v-icon v-else>
          mdi-account-circle
        </v-icon>
      </v-list-item-avatar>

    </v-app-bar>

    <!-- Navigation Droite -->
    <v-navigation-drawer
      v-if="loggedIn"
      v-model="drawer2"
      color="background"
      right
      temporary
      app
      :dark="$vuetify.theme.dark"
    >
      <v-list class="py-0">
        <v-list-item v-if="loggedIn" two-line>
          <v-list-item-avatar>
            <v-img
              v-if="userData.avatar"
              :alt="`${userData.firstName}'s avatar`"
              :src="$functions.getImgLink(userData.avatar, 200)"
            />
            <v-icon v-else>
              mdi-account-circle
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ userData.firstName }} {{ userData.lastName }}</v-list-item-title>
            <v-list-item-subtitle v-if="userData.company">{{ compData.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item v-for="item in items" :key="item.title" link router :to="item.route">

          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>

        </v-list-item>

        <div v-if="loggedIn">

          <v-divider />

          <v-list-group no-action prepend-icon="mdi-office-building">
            <template v-slot:activator>
              <v-list-item-title>Entreprises</v-list-item-title>
            </template>

            <v-list-item v-for="item in companies" :key="item.title" @click="changeCompany(item.id, item.name)">

              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          </v-list-group>

          <v-divider />
        </div>
      </v-list>

      <template v-slot:append>
        <v-list-item v-if="loggedIn" link router to="/help">
          <v-list-item-icon>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Aide</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="loggedIn" link @click="dialogs.logoutConfirm = true">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Déconnexion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-dialog v-model="dialogs.logoutConfirm" max-width="400">
        <v-card>
          <v-card-title class="text-h5">Déconnexion</v-card-title>
          <v-card-text>
            Voulez-vous vraiment vous déconnecter ?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="dialogs.logoutConfirm = false">Annuler</v-btn>
            <v-btn text color="error" @click="signOut">Confirmer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>

    <!-- Navigation Gauche -->

    <v-navigation-drawer
      v-if="loggedIn"
      v-model="drawer"
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      :permanent="$vuetify.breakpoint.mdAndUp"
      app
      collapse
      :dark="$vuetify.theme.dark"
      :style="$vuetify.theme.dark
        ? 'background-color: rgba(38, 43, 53, 0.72); backdrop-filter: blur(10px);'
        : 'background-color: rgba(244, 246, 248, 0.92); backdrop-filter: blur(10px);'"
    >
      <v-list>
        <v-list-item v-for="link in links" :key="link.route" router :to="link.route">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list v-show="adminAccess">
        <v-list-item v-for="link in adminLinks" :key="link.text" router :to="link.route">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>

    <NotificationsDrawer
      v-model="drawerNotifications"
      :admin-access="adminAccess"
    />

    <!-- Overlay -->
    <div
      v-if="drawer2"
      style="position: absolute; top: 0; left: 0; z-index: 6; backdrop-filter: blur(30px);"
    />

  </nav>
</template>

<script>
import { setSnackbar } from "@/stores/ui";
import DarkModeSwitch from "@/components/modules/@widgets/DarkModeSwitch";
import TaskAddDialog from "@/components/modules/@tasks/TaskAddDialog";
import NotificationsDrawer from "@/components/NotificationsDrawer.vue";

import { useUserStore } from "@/stores/user";
import { useCompanyStore } from "@/stores/company";
import { useNotificationsStore } from "@/stores/notifications";
import { captureException, reset as resetPostHog } from "@/posthog";

export default {
  props: {
    id: {
      type: String,
    },
  },
  components: {
    DarkModeSwitch,
    TaskAddDialog,
    NotificationsDrawer,
  },
  setup() {
    const userStore = useUserStore();
    const companyStore = useCompanyStore();
    const notificationsStore = useNotificationsStore();
    return { userStore, companyStore, notificationsStore };
  },
  data() {
    const itemsList = this.$firebase.auth().currentUser
      ? [{
        title: "Profil",
        icon: "mdi-account",
        route: "/profile",
      }, {
        title: "Mon Entreprise",
        icon: "mdi-office-building-outline",
        route: "/my-company",
      }]
      : [{
        title: "Se connecter",
        icon: "mdi-login",
        route: "/login",
      }];

    return {
      dialogs: {
        todo: false,
        genQR: false,
        logoutConfirm: false,
      },

      drawer: false,
      drawer2: false,
      drawerNotifications: false,

      darkMode: this.$vuetify.theme.dark,

      links: [],
      adminLinks: [{
        icon: "mdi-shield-key-outline",
        text: "Administration",
        route: "/administration",
      }, {
        icon: "mdi-shield-edit-outline",
        text: "Création",
        route: "/administration/creation",
      }, {
        icon: "mdi-package-variant-closed",
        text: "Catalogue",
        route: "/administration/catalog",
      }, {
        icon: "mdi-bell-badge-outline",
        text: "Notifications",
        route: "/administration/notifications",
      }],

      items: itemsList,
      companies: [],
      adminAccess: false,
      adminListenerUnsubscribe: null,
    };
  },
  computed: {
    loggedIn() {
      return !!this.userStore.user; // Or check auth currentUser
    },
    userData() {
      return this.userStore.user || this.$models.user;
    },
    compData() {
      return this.companyStore.company || this.$models.company;
    },
  },
  watch: {
    "userStore.user": {
      handler(user) {
        if (user) {
          this.setupAdminListener(user.id);
          this.loadCompaniesList(user.id);
        } else {
          this.adminAccess = false;
          this.companies = [];
          this.resetNav();

          if (typeof this.adminListenerUnsubscribe === "function")
            this.adminListenerUnsubscribe();


          this.adminListenerUnsubscribe = null;
        }
      },
      immediate: true,
    },
    "companyStore.company": {
      handler(company) {
        this.resetNav();
        this.buildNavLinks();
        const companyId = company?.id || this.userStore.user?.company;
        if (companyId) this.notificationsStore.ensureWatch(companyId);
        else this.notificationsStore.resetState();
      },
      immediate: true,
    },
    "userStore.user.company"(companyId) {
      if (companyId) this.notificationsStore.ensureWatch(companyId);
    },
    "companyStore.modules": {
      handler() {
        if (!this.companyStore.loading) {
          this.resetNav();
          this.buildNavLinks();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.changeDarkTheme();
  },
  methods: {
    changeDarkTheme() {
      const favicon = document.getElementById("favicon");

      this.darkMode = this.$vuetify.theme.dark;

      if (this.darkMode) favicon.href = "https://cdn.infographart.com/logos/KATANA/favicon.ico";
    },
    resetNav() {
      this.links = [{
        icon: "mdi-view-dashboard",
        text: "Tableau de bord",
        route: "/",
        id: 0,
      }];
    },
    setupAdminListener(uid) {
      if (typeof this.adminListenerUnsubscribe === "function")
        this.adminListenerUnsubscribe();


      this.$api.apiUser({ url: `/users/${uid}/ranks/BzAcMoJjpbCaNFyQSJ3N` }).then((res) => {
        this.adminAccess = !!res.data.exists;
      }).catch(() => {
        this.adminAccess = false;
      });
    },
    loadCompaniesList(uid) {
      this.companies = [];

      this.$api.apiUser({
        method: "get",
        url: `/users/${uid}/companies`,
      }).then((res) => {
        this.companies = (res.data.documents || [])
          .map((company) => ({
            avatar: company.avatar || "",
            name: company.name || "Inconnu",
            email: company.email || "",
            website: company.website || "",
            id: company.id,
          }))
          .sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()));
      });
    },
    buildNavLinks() {
      if (this.companyStore.loading) return;

      // Construction de la navigation avec les liens dont a accès l'entreprise
      this.controlNavLinks("WMNeXSrh3zlFzIBCZPAq", {
        icon: "mdi-folder-account",
        text: "Clients",
        route: "/customers",
      });

      this.controlNavLinks("WMNeXSrh3zlFzIBCZPAq", {
        icon: "mdi-domain",
        text: "Entreprises",
        route: "/companies",
      });

      this.controlNavLinks("YzeCWO5vQIgYKrdZCuWz", {
        icon: "mdi-clipboard-multiple-outline",
        text: "Devis",
        route: "/quotes",
      });

      this.controlNavLinks("JAms0PMwguesdZvvXvIL", {
        icon: "mdi-cash-multiple",
        text: "Factures",
        route: "/invoices",
      });

      this.controlNavLinks("kEUEhxSoDZWSVjNkGIy7", {
        icon: "mdi-truck-outline",
        text: "Logistique",
        route: "/logistics",
      });

      this.controlNavLinks("kEUEhxSoDZWSVjNkGIy7", {
        icon: "mdi-warehouse",
        text: "Entrepôts",
        route: "/warehouses",
      });

      this.controlNavLinks("Dk1wdkEvdgyIPmJAg1uv", {
        icon: "mdi-folder",
        text: "Projets",
        route: "/projects",
      });

      this.controlNavLinks("dBNa5WjEnL1tjUJBDVHd", {
        icon: "mdi-cube",
        text: "Produits",
        route: "/products",
      });

      this.controlNavLinks("zS95PXCJ8QRCXsNgRMSX", {
        icon: "mdi-newspaper",
        text: "Blogs",
        route: "/blogs",
      });

      this.controlNavLinks("GPvYlONpjCDqzW6sckkw", {
        icon: "mdi-account-multiple",
        text: "Équipes",
        route: "/team",
      });

      this.links.push({
        icon: "mdi-wrench",
        text: "Outils",
        route: "/tools",
        id: "outils",
      });
    },
    controlNavLinks(module, linkToAdd) {
      if (!this.companyStore.modules) return;

      const hasAccess = this.companyStore.modules.some(m => m.id === module);
      const index = this.links.findIndex(l => l.id === module && l.route === linkToAdd.route);

      if (hasAccess && index === -1)
        this.links.push({
          ...linkToAdd,
          id: module,
        });
    },
    async changeCompany(compID, compName) {
      this.drawer2 = false;

      if (!this.$route.meta.safePlace)
        await this.$router.replace({
          path: "/",
        });

      // Use Store Action
      this.userStore.updateUserCompany(compID).then(() => {
        setSnackbar({
          text: `Votre entreprise active est désormais ${compName}.`,
          color: "info",
        });
      }).catch((err) => {
        setSnackbar({
          text: err.message || err,
          color: "error",
        });
      });
    },
    async signOut() {
      try {
        await this.$firebase.auth().signOut();
        this.$api.clearApiSession();
        resetPostHog();
        this.userStore.stopUserListener();
        this.companyStore.stopCompanyListener();

        this.$router.replace({
          path: "/login",
        });
      } catch (err) {
        console.log(err);
        captureException(err, {
          flow: "sign_out",
        });
      }
    },
  },
  beforeUnmount() {
    if (typeof this.adminListenerUnsubscribe === "function")
      this.adminListenerUnsubscribe();


    this.adminListenerUnsubscribe = null;
  },
};
</script>
